import type { CSSProperties } from 'react';
import styled from 'styled-components';

import winterLogo from './assets/wntr.svg';

const StyledImg = styled.img`
  object-fit: contain;
`;

type Props = {
  className?: string;
  style?: CSSProperties;
};
export const WinterLogo = ({ className, style }: Props) => {
  return (
    <StyledImg
      src={winterLogo}
      alt="WNTR"
      className={className}
      style={style}
    />
  );
};
